// ============================================================
// TERROR ENGINE — CDN
// One file. One domain. One truth.
// Every image in every zone pulls from here.
// To move assets to a new domain: change one line.
// ============================================================

import { baseId } from "./necroSeal";

export const CDN = "https://terror-assets.pages.dev";

// ── Asset URL helpers ─────────────────────────────────────────
export const cdnUrl  = (filename) => `${CDN}/${filename}`;

// ── THE SEAL STRIP (July 28, 2026) ────────────────────────────
// THE BUG THIS CLOSES: the Necro Seal stamps a ruined being with an
// identity tag — spectral_tiger_lord becomes spectral_tiger_lord~0~3.
// getCard() strips that tag, so every stat, name and effect kept
// working and the seal looked invisible. But art is not a LOOKUP, it
// is a STRING CONCATENATION — this function was handing the CDN
//
//     terror-assets.pages.dev/spectral_tiger_lord~0~3.webp
//
// which is a file that has never existed. Every being that had ever
// been ruined lost its picture: on the 2D board, in the inspect modal,
// on the Necropolis pile, and — worst — on the 3D board, where a
// faceless slab sits directly on top of the Escling and reads as
// "the Escling replaced my being."
//
// One strip, here, at the single place every card image in the game is
// built. A bare catalog id passes through untouched, so nothing that
// was already working can notice.
//
// ── THE RENAME THAT NEVER REACHED THE CDN (2026-09-15) ────────
// caP'n: "we renamed Chao to Khao so I am sure that is what's going on."
// It is. The six Khao Tomes are `tome_khao_*` in cards.js and in
// Assets/terror-assets on disk, but terror-assets.pages.dev still serves
// only the OLD `tome_chao_*` files (HEAD on the khao names → 404, on the
// chao names → 200, checked 2026-09-15). So every surface — 2D board,
// Codex, Deck Builder, 3D board — drew six blank slabs. The id is the
// id; only the FILE differs, so the alias lives here, at the one place
// every card image in the game is built. ⚠ Delete this table the day
// the six `tome_khao_*.webp` are deployed to the CDN — nothing else
// needs to change, and a stale alias would then hide a real 404.
const ART_FILE = {
  tome_khao_garden:            "tome_chao_garden",
  tome_khao_arcadia:           "tome_chao_arcadia",
  tome_khao_paradise:          "tome_chao_paradise",
  tome_khao_duhmdumn_beb:      "tome_chao_duhmdumn_beb",
  tome_khao_duhmdumn_champion: "tome_chao_duhmdumn_champion",
  tome_khao_duhmdumn_lord:     "tome_chao_duhmdumn_lord",
};
export const artFile = (cardId) => { const id = baseId(cardId); return ART_FILE[id] || id; };
export const cardUrl = (cardId) => `${CDN}/${artFile(cardId)}.webp`;
